<h1 mat-dialog-title *ngIf="data && !data.info">{{'WARNING'| translate}}</h1>
<h1 mat-dialog-title *ngIf="data && data.info" class="model-info-heading">{{ 'InformationLabel' | translate}}</h1>
<div class="conf-popup-wrap">
  <hr>
  <div mat-dialog-content>
    <span [innerHTML]="data && data.label? data.label : 'CONFIG_LABEL | translate'"> </span>
  </div>
  <hr>
  <div mat-dialog-actions class="conf-popup-btn-wrap">

    <button type="button" mat-raised-button class="dialog-yes-btn" mat-button (click)="onClickOk(true)">
      {{data && data.cancelLabelName?data.cancelLabelName:'OK'}}
    </button>
  </div>
</div>